var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 25,
  viewBox: "0 0 28 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28 7.0164C28 3.14167 24.8583 0 20.9836 0C17.3246 0 14.3239 2.80168 14 6.3769C13.6768 2.80168 10.6754 0 7.0164 0C3.14167 0 0 3.14167 0 7.0164C0 8.97261 0.802888 10.7403 2.09377 12.0138L12.5276 24.0317C13.304 24.926 14.6926 24.926 15.4689 24.0317L25.8574 12.0563C27.1755 10.7815 27.9993 8.99635 27.9993 7.0164"
})));
export default SvgHeart;